import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { chatbotService } from '../../../services/ChatbotService';
import { chatbotQueryKeys } from '../chatbotQueryKeys';

export function useChatbotConversationQuery(
  chatbotId: string | undefined,
  conversationId: string | undefined,
) {
  const { user } = useAuth();
  const resolvedChatbotId = chatbotId?.trim() ?? '';
  const resolvedConversationId = conversationId?.trim() ?? '';
  const isEnabled =
    Boolean(user) &&
    resolvedChatbotId.length > 0 &&
    resolvedConversationId.length > 0;

  return useQuery({
    queryKey: chatbotQueryKeys.conversation(
      resolvedChatbotId,
      resolvedConversationId,
    ),
    enabled: isEnabled,
    queryFn: () =>
      chatbotService.getConversation(resolvedChatbotId, resolvedConversationId),
  });
}
